import { PolicyGroups } from "@constants/Policies";
import { PeekMultipleSelector } from "@piiqtechnologies/ui-components";
import React, { useMemo } from "react";
const FeaturesSelector = ({ field, form, label }) => {
    const selectItems = useMemo(() => Object.values(PolicyGroups.FEATURE_GATING).map((feature) => ({ _id: feature, name: feature })), []);
    const handleSelectFeatures = (features) => {
        // @ts-ignore
        form.setFieldValue(field.name, features);
    };
    return (React.createElement(PeekMultipleSelector, { form: form, field: field, label: label, options: selectItems, selectedOptions: field.value, onSelectionChange: handleSelectFeatures }));
};
export default FeaturesSelector;
